import {  createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import reducer from './reducers';

export const history = createHistory();

const initialState = {

};

const enhancers = [];
const middleware = [
  routerMiddleware( history )
];

const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if ( typeof devToolsExtension === 'function' ) {
  enhancers.push( devToolsExtension() );
}

const composedEnhancers = compose(
  applyMiddleware( ...middleware ),
  ...enhancers
);

export default createStore( reducer, initialState, composedEnhancers );



// WEBPACK FOOTER //
// ./src/redux/store.js